// extracted by mini-css-extract-plugin
export var graphic = "WhoWeDoItFor-module--graphic--2wk7P";
export var svg = "WhoWeDoItFor-module--svg--2-Q94";
export var dashed = "WhoWeDoItFor-module--dashed--1omIG";